import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("登録します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("よろしいでしょうか。")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "rental_contract_confirm_notice" }, [
  /*#__PURE__*/_createTextVNode(" スケジュール情報が「確認待ち」に更新されます。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}